import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=06688b9a&scoped=true"
import script from "./UsersEdit.vue?vue&type=script&lang=js"
export * from "./UsersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06688b9a",
  null
  
)

export default component.exports